'use client';

import { RegisterForm } from '@/components/features/auth/RegisterForm';

export default function RegisterPage() {
    return <RegisterForm />;
}
